
const ADD_USER = "AdminRoutes/POSTUsers"; 
const EDIT_USER = "AdminRoutes/UPDTUsers"; 
const GET_USERS = "AdminRoutes/getUsers"; 
const USER_INACTIVE = "AdminRoutes/UsersInActive"; 

export { ADD_USER, EDIT_USER, GET_USERS, USER_INACTIVE };
  